<template>
	<db-col :height="height" valign="middle" class="field-signle-wrapper" @click="clickHandler">
		<db-row height="auto" valign="middle" class="auto-fill">
			<db-col height="auto" valign="middle" class="field-text">{{label}}</db-col>
			<db-col height="auto" valign="middle" class="field-sub-text" v-if="subLabel">{{subLabel}}</db-col>
		</db-row>
		<db-col width="30" />
		<db-col :width="width" valign="middle" align="right" class="field-value" wrap>{{value}}</db-col>
		<db-icon :icon="suffixIcon" v-if="suffixIcon" color="#999" />
	</db-col>
</template>

<script>
	export default {
		name: 'field_',
		
		props: {
			width: {
				type: [String, Number],
				default: '180'
			},
			
			height: {
				type: [String, Number],
				default: '90'
			},
			
			label: {
				type: [String, Number],
				default: ''
			},
			
			subLabel: {
				type: [String, Number],
				default: ''
			},
			
			value: {
				type: [String, Number],
				default: ''
			},
			
			suffixIcon: {
				type: String,
				default: ''
			}
		},
		
		methods: {
			clickHandler(){
				this.$emit('click')
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.field-signle-wrapper{
		.field-text{
			color: #333;
			font-size: 28px;
		}
		
		.field-sub-text{
			color: #999;
			font-size: 24px;
			margin-top: 10px;
		}
		
		.field-value{
			color: #999;
			font-size: 24px;
		}
	}
</style>
